var _rect, _circle, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCornerLowerLeftLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 106,
    viewBox: "0 0 80 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 53.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8453 65.333H51.2453V51.533C51.2453 48.133 51.2453 40.733 40.9953 40.733C37.1953 40.733 33.4453 41.883 30.7953 44.583L33.9453 47.733C35.5453 46.233 37.8453 45.233 40.3453 45.233C43.5453 45.233 45.8453 46.783 45.8453 49.733V50.383H44.3453C38.3453 50.383 29.2453 50.933 29.2453 58.733C29.2453 63.483 33.5453 65.933 37.9953 65.933C41.1953 65.933 43.9953 64.733 45.6953 62.033H45.8453V65.333ZM45.4953 55.933C45.4953 59.283 43.5453 61.433 39.4453 61.433C37.4953 61.433 35.2453 60.483 35.2453 58.283C35.2453 54.833 40.9453 54.583 44.2453 54.583H45.4953V55.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33398,
    y: 83.5557,
    width: 2.5,
    height: 14,
    rx: 1.25,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCornerLowerLeftLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-corner-lowerLeft-left.5c518d133dd3fae6546d0b3f50fe888d.svg";
export { ForwardRef as ReactComponent };